import * as React from "react";
import { Tab } from "semantic-ui-react";
import { TransportOrderScriptView } from "./scriptViews/TransportOrderScriptView";
import { TransportScriptView } from "./scriptViews/TransportScriptView";
import { StopScriptView } from "./scriptViews/StopScriptView";
import { FreightScriptView } from "./scriptViews/FreightScriptView";
import {clampTabIndex} from "../../../context/TabSession";

const panes = [
    { menuItem: 'TransportOrder', render: props => <Tab.Pane><TransportOrderScriptView /></Tab.Pane> },
    { menuItem: 'Transport', render: props => <Tab.Pane><TransportScriptView /></Tab.Pane> },
    { menuItem: 'Stop', render: props => <Tab.Pane><StopScriptView /></Tab.Pane> },
    { menuItem: 'Freight', render: props => <Tab.Pane><FreightScriptView /></Tab.Pane> },

]

const TabMenuMultiScript = props => <Tab
    {...props = props} panes={panes}
    defaultActiveIndex={clampTabIndex(props.context.tabSession.multiScriptTab, panes)}
    onTabChange={(_, data) => {
        props.context.setSingleTabSession("multiScriptTab", data.activeIndex)
    }}
/>

export default TabMenuMultiScript